import React from 'react';
import Papa from 'papaparse';

function ImportarClientes({ onImportar }) {
  const handleArchivo = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const filas = results.data;

        // Agrupar por cliente usando código de cliente si está presente
        const clientesMap = new Map();

        filas.forEach(row => {
          const clave = row.codigo_cliente || `${row.nombre_cliente}__${row.telefono}`;

          if (!clientesMap.has(clave)) {
            clientesMap.set(clave, {
              codigo_cliente: row.codigo_cliente || '',
              nombre: row.nombre_cliente,
              telefono: row.telefono,
              observaciones: row.observaciones || '',
              ordenadores: []
            });
          }

          clientesMap.get(clave).ordenadores.push({
            descripcion: row.descripcion_ordenador,
            info_adicional: row.info_adicional || ''
          });
        });

        onImportar(Array.from(clientesMap.values()));
      }
    });
  };

  return (
    <label className="button secondary" style={{ cursor: 'pointer' }}>
      📂 Importar CSV
      <input type="file" accept=".csv" onChange={handleArchivo} hidden />
    </label>
  );
}

export default ImportarClientes;
